import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-xl font-bold font-heading text-foreground-50 whitespace-nowrap">
                韩漫漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-400">
                <i className="ri-mail-line mr-2"></i>
                {siteInfo.email}
              </li>
              <li className="text-sm text-foreground-400">
                <i className="ri-phone-line mr-2"></i>
                {siteInfo.phone}
              </li>
              <li className="text-sm text-foreground-400">
                <i className="ri-map-pin-line mr-2"></i>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备2024xxxxxxxx号
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}